exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "purchase-record>ul{font-size:0}purchase-record>ul>li{font-size:1rem;display:inline-block;vertical-align:middle}purchase-record>ul .status:before{content:\"\";display:inline-block;margin-right:.5em;width:.8em;height:.8em;border-radius:50%}purchase-record>ul .status.FINISHED,purchase-record>ul .status.INACTIVE{color:#c42720}purchase-record>ul .status.FINISHED:before,purchase-record>ul .status.INACTIVE:before{background-color:#c42720}purchase-record>ul .status.ACTIVE{color:#38a104}purchase-record>ul .status.ACTIVE:before{background-color:#38a104}purchase-record>ul .status.INPROGRESS:before{background-color:#ffde00}@media (min-width:900px){purchase-record>ul{display:table;width:100%}purchase-record>ul>li{display:table-cell;vertical-align:middle}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./src/app/pages/vehicle/manage-my-rlink/components/purchase-record/purchase-record.styl
// module id = 1153
// module chunks = 0